import { render, staticRenderFns } from "./PurchaseOrderTemplate.vue?vue&type=template&id=e6ae6c4e&scoped=true&"
import script from "./PurchaseOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderTemplate.vue?vue&type=style&index=0&id=e6ae6c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae6c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
